import request from '@/utils/http'
import { PFX, SRM_FILE_PRE } from '../../constant/constant.js'
// 查询
export const getTableListData = params => {
    return request({
        url: `${PFX}/analysis/analysisTenderCostDetail/${params}`,
        method: 'get',
    })
}

// 保存
export const getTenderCost = data => {
    return request({
        url: `${PFX}/analysis/analysisTenderCost`,
        method: 'post',
        data,
    })
}

// mip流程创建
export const getMipData = data => {
    return request({
        url: `${PFX}/analysis/creatTenderCostFlow`,
        method: 'post',
        data,
    })
}

// 下发通知书-确认
export const getSendMail = data => {
    return request({
        url: `${PFX}/analysisIssueNotice/sendMail`,
        method: 'post',
        data,
    })
}
// 投标报价表格导出
export const exportQuote = data => {
    return request({
        url: `${PFX}/analysis/exportAnalysisTenderQuotes`,
        method: 'post',
        params: data,
        responseType: 'arraybuffer',
    })
}

// 投标报价表格导入
export const importQuote = (data, code, status) => {
    return request({
        url: `${PFX}/analysis/importTenderQuote?projectCode=${code}&status=${status}`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: data,
    })
}

// 投标报价匹配线路
export const matchingLine = params => {
    return request({
        url: `${PFX}/analysis/tenderQuotes/matchLine`,
        method: 'post',
        params: params,
    })
}

// 投标报价查询分页
export const getTenderQuotes = params => {
    return request({
        url: `${PFX}/analysis/queryQuoteInfos`,
        method: 'post',
        data: params,
    })
}

// 获取汇总测试数据
export const getCalculationData = params => {
    return request({
        url: `${PFX}/analysisTenderCalculation/getCalculationData?projectCode=${params}`,
        method: 'post',
    })
}
// 计算汇总测试数据
export const genCalculationData = params => {
    return request({
        url: `${PFX}/analysisTenderCalculation/genCalculationData`,
        method: 'post',
        data: params,
    })
}
// 导出汇总测试数据
export const exportGenCalculationData = data => {
    return request({
        url: `${SRM_FILE_PRE}/analysisTenderCalculation/exportAnalysisTenderCalculationExcel`,
        method: 'post',
        data,
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 生成合同(参数：项目编码)
export const creatLmdmContract = id => {
    return request({
        url: `${PFX}/analysisTenderCalculation/creatLmdmContract/${id}`,
        method: 'post',
    })
}
// 是否达准入项目经营中心利润
export const checkAnalysisCost = params => {
    return request({
        url: `${PFX}/analysis/checkAllowSubmitAnalysisCost`,
        method: 'get',
        params,
    })
}
// 获取员工信用积分消息
export const getScoreMsg = data => {
    return request({
        url: `${PFX}/analysis/getCreditScoresMessage/${data}`,
        method: 'get',
    })
}
// 提交审批-积分校验
export const checkCreditScores = params => {
    return request({
        url: `${PFX}/analysis/checkCreditScores`,
        method: 'get',
        params,
    })
}

// 风险提示
export const getOpportunityMsg = data => {
    return request({
        url: `${PFX}/analysis/getOpportunityMessage/${data}`,
        method: 'get',
    })
}

// 查询
export const getPmsProjectInfoDetail = data => {
    return request({
        url: `${PFX}/analysis/getPmsProjectInfoDetail/${data}`,
        method: 'get',
    })
}

// 查询当前流程是否N1节点
export const checkStartNode = data => {
    return request({
        url: `${PFX}/analysis/checkProcessInfoIsStartNode`,
        method: 'post',
        data,
    })
}

// 成本审批提交前校验
export const checkAllowTenderCost = data => {
    return request({
        url: `${PFX}/analysis/checkAllowSubmitTenderCostFlow`,
        method: 'get',
        params: data,
    })
}

// 重新报价
export const reQuote = data => {
    return request({
        url: `${PFX}/analysis/reQuote/${data}`,
        method: 'get',
        // params: data,
    })
}

// 判断结算方式或承兑比例是否一致
export const acceptScaleWarning = data => {
    return request({
        url: `${PFX}/analysis/acceptScaleWarning/${data}`,
        method: 'get',
        // params: data,
        })
    }

// 查询招标流程是否需要弹提示，true是驳回需要提示，false不需要
export const queryFlowAuditIsRefuse = params => {
    return request({
        url: `${PFX}/bid/queryFlowAuditIsRefuse`,
        method: 'get',
        params
    })
}

// 招标结果上传附件列表查询接口
export const uplaodQueryByBidNo = (params) => {
    return request({
        url: `${PFX}/bid/bidResultAttachment/queryByBidNo/${params.bidNo}`,
        method: 'get',
        params
    });
};

// 查询招标结果的流程状态
export const queryAuditStatus = (params) => {
    return request({
        url: `${PFX}/bid/bidResultAttachment/queryAuditStatus/${params.bidNo}`,
        method: 'get',
        params
    });
};

// mip审批页面查询投标报价的关键信息分页接口
export const searchOpportunityInfos = data => {
    return request({
        url: `${PFX}/analysis/searchOpportunityInfos`,
        method: 'post',
        data,
    })
}

// 同步信息及商机、中标信息-是否中标值变更时，均需要调这个接口（销售易）
export const checkProjectBeforeUpdate = data => {
    return request({
        url: `${PFX}/analysis/analysisTenderCost/checkProjectBeforeUpdate`,
        method: 'post',
        data,
    })
}

// 成本及报价审批值变更时调这个接口
export const checkProjectBeforeUpdateNew = data => {
    return request({
        url: `${PFX}/analysis/analysisTenderCost/checkProjectBeforeUpdateNew`,
        method: 'post',
        data,
    })
}

// 获取成本审批IFlow流程信息
export const getFlowInfo = params => {
    return request({
        url: `${PFX}/analysis/cost/getFlowInfo/${params}`,
        method: 'get',
    })
}

// 创建成本流程
export const createCostFlow = (data) => {
    return request({
        url: `/api-srm-web/analysis/cost/createCostFlow`,
        method: 'post',
        data
    });
};